import React from 'react';
import { AccountType } from '../types';

interface AccountTypeIndicatorProps {
  accountType: AccountType;
  showLabel?: boolean;
}

const AccountTypeIndicator: React.FC<AccountTypeIndicatorProps> = ({
  accountType,
  showLabel = true
}) => {
  const getTypeConfig = () => {
    switch (accountType) {
      case AccountType.GUEST:
        return {
          bgColor: 'bg-yellow-100',
          textColor: 'text-yellow-800',
          label: 'Guest Account',
          description: 'Limited features, data may be lost'
        };
      case AccountType.PREMIUM:
        return {
          bgColor: 'bg-purple-100',
          textColor: 'text-purple-800',
          label: 'Premium Account',
          description: 'Full access to all features'
        };
      case AccountType.REGISTERED:
      default:
        return {
          bgColor: 'bg-blue-100',
          textColor: 'text-blue-800',
          label: 'Registered Account',
          description: 'Full account with data backup'
        };
    }
  };

  const config = getTypeConfig();

  return (
    <div className="flex items-center space-x-2">
      <span 
        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor}`}
      >
        {config.label}
      </span>
      {showLabel && (
        <span className="text-sm text-gray-500">{config.description}</span>
      )}
    </div>
  );
};

export default AccountTypeIndicator; 